import React from 'react';
import { t } from '@lingui/macro';
// eslint-disable-next-line no-restricted-imports
import { Tooltip, Box, Skeleton, Image, Link } from '@landr/maestro';
import { Link as ReactRouterLink } from 'react-router-dom';
import { getImageUrl } from 'helpers';
import addQueryStringTo from 'helpers/addQueryStringTo';
import { RoutePaths } from 'types/enums';
import { packIcon, wrapperLinkPackIcon } from './SamplesTablePackIcon.styled';
import { SamplesTablePackIconProps } from './SamplesTablePackIcon.types';

export const SamplesTablePackIconSkeleton = () => <Skeleton height="sm" />;

export const SamplesTablePackIcon: React.FC<SamplesTablePackIconProps> =
    React.memo(
        ({ packSlug, packName, packArtworkUrl, onClick }) => {
            return (
                <Link
                    className={wrapperLinkPackIcon}
                    to={addQueryStringTo(`/${RoutePaths.Packs}/${packSlug}`)}
                    as={ReactRouterLink}
                    onClick={onClick}
                >
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Tooltip position="top" hasArrow content={packName}>
                            <Image
                                className={packIcon}
                                loading="lazy"
                                src={
                                    packArtworkUrl &&
                                    getImageUrl({
                                        imageUrl: packArtworkUrl,
                                        width: 36,
                                    })
                                }
                                fallbackSrc={`${
                                    import.meta.env.BASE_URL
                                }assets/fallback/artworkPlaceholder.svg`}
                                alt={t`Artwork of ${packName}`}
                            />
                        </Tooltip>
                    </Box>
                </Link>
            );
        },
        (prevProps, nextProps) => {
            // Compare each prop individually
            return (
                prevProps.packSlug === nextProps.packSlug &&
                prevProps.packName === nextProps.packName &&
                prevProps.packArtworkUrl === nextProps.packArtworkUrl &&
                prevProps.onClick === nextProps.onClick
            );
        },
    );
